import { useState, useCallback } from 'react';

function useReRender() {
  const [, update] = useState(0);
  const reRender = useCallback(() => {
    update(prev => prev + 1);
  }, []);
  return reRender;
}

export { useReRender };
//# sourceMappingURL=useReRender.js.map
